import * as React from "react";

function SvgDividerIcon(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" {...props}><path d="M.8 10.8c-.5 0-.8-.4-.8-.8s.3-.8.8-.8h18.5c.4 0 .8.3.8.8s-.3.8-.8.8H.8" /></svg>;
}

export default SvgDividerIcon;